import { ValdrValidator, ValidatorConfig } from '@app/valdr/models';
import { hasValue } from '@app/valdr/util';
import * as R from 'ramda';

export const requiredValidator: ValdrValidator = R.curry((config: ValidatorConfig, value: any) =>
  hasValue(value)
);
